/**
 * Sorts colors by active colors followed by disabled colors at the end.
 * */
export const getSortedInputs = (inputs) => {
    if (!(inputs === null || inputs === void 0 ? void 0 : inputs.length)) {
        return undefined;
    }
    const disabledInputs = inputs.filter((input) => input.disabled === true);
    const activeInputs = inputs.filter((input) => input.disabled !== true);
    return activeInputs.concat(disabledInputs);
};
